export class ColorTranslation {
  public en: string;
  public ar: string;
  public hex: string;

  constructor() {
    this.en = '';
    this.ar = '';
    this.hex = '';
  }
}

export const parseColorTranslationFromJson = (data?: any | null): any => {
  const out: Record<string, ColorTranslation> = {};
  if (!data) {
    console.warn('parseColorTranslationFromJson: No data provided');
    return out;
  }
  data = JSON.parse(data);
  console.log('parseColorTranslationFromJson', data);

  if (data) {
    // iterate the object keys
    for (const item of Object.keys(data)) {
      // check if the item has en, ar, and hex properties
      // and create a new ColorTranslation instance
      if (data[item] && data[item].en && data[item].ar && data[item].hex) {
        out[item as string] = new ColorTranslation();
        out[item].en = data[item].en || '';
        out[item].ar = data[item].ar || '';
        out[item].hex = data[item].hex || '';
      } else {
        console.warn(`Invalid color translation item: ${item}`, data[item]);
      }
    }
  }

  console.log('parseColorTranslationFromJson out', out);
  return out;
};

export const parseColorTranslation = (data?: any): ColorTranslation => {
  let out = new ColorTranslation();
  if (data) {
    out = new ColorTranslation();
    out.en = data.en || '';
    out.ar = data.ar || '';
    out.hex = data.hex || '';
  }
  return out;
};
